class StickScroll {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.element = self.elem.querySelector('[data-stick-scroll-element]');
        self.item = self.elem.querySelector('[data-stick-scroll-item]');
        self.end = self.elem.querySelector('[data-stick-scroll-end]');
    }

    init() {
        let self = this;

        self.stickyItem();

        window.onresize = function(event) {
            self.stickyItem();
        };
    }

    stickyItem() {
        let self = this;

        const top = 300;

        document.addEventListener('scroll', (e) => {
            const offsetTop = self.elem.getBoundingClientRect().top + document.documentElement.scrollTop - top;

            if (window.scrollY > offsetTop) {
                self.item.classList.add('is-sticky');
                self.element.classList.add('is-sticky');
            } else {
                self.item.classList.remove('is-sticky');
                self.element.classList.remove('is-sticky');
            }

            const bounding = self.end.getBoundingClientRect();
            const calc = self.item.offsetHeight + top;

            if (calc > bounding.y) {
                self.item.classList.add('is-stuck');
            } else {
                self.item.classList.remove('is-stuck');
            }
        });
    }
}

export default StickScroll;
